import {Instance, types as t} from 'mobx-state-tree';
import {AbstractQuestion} from '../abstract-question.store';
import {BlankCorrectAnswer} from '../CorrectOption/_extends/blank-correct-answer.store';
import {BlankItem} from '../Blank/blank-item.store';

export const TableCompletionUserAnswer = t.model({
  blankId: t.maybeNull<any>(t.string),
  userAnswer: t.maybeNull<any>(t.string),
});

export interface TableCompletionUserAnswerInstance
  extends Instance<typeof TableCompletionUserAnswer> {}

export const TableCompletion = AbstractQuestion.named('TableCompletion').props({
  question: t.maybeNull<any>(t.string),
  correctAnswers: t.array(BlankCorrectAnswer),
  userAnswers: t.array(TableCompletionUserAnswer),
  blanks: t.array(BlankItem),
  editorValue: t.maybeNull<any>(t.string),
});

t.snapshotProcessor(TableCompletion, {
  preProcessor(snapshot: any) {
    const { editorValues, blanks, ...rest } = snapshot;
    return {
      ...rest,
      blanks: (blanks || []).map((bl: any) => ({ ...bl, blankId: bl.id })),
    };
  },
});

export function preProcessor(snapshot: any) {
  const { blanks, userAnswers } = snapshot;
  return {
    ...snapshot,
    userAnswers: (blanks || []).map(({ id }) => {
      const userAnswerFound = userAnswers.find((ua) => ua.blankId === id);
      return { blankId: id, userAnswer: userAnswerFound?.userAnswer || '' };
    }),
  };
}

